import { ChangeDetectorRef, Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { IUser, IUserStatus } from 'pi-types';

import { SvgIconComponent } from 'angular-svg-icon';
import { takeUntilDestroyedSafe } from '@core/helpers/take-until-destroyed-safe';

interface MenuItem {
  title: string;
  url: string;
  icon?: string;
}

@Component({
    selector: 'app-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss'],
    imports: [RouterLink, SvgIconComponent]
})
export class SidebarMenuComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  private readonly authService = inject(AuthService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);

  user!: IUser;
  userStatus!: IUserStatus;

  public menuItems: MenuItem[] = [];

  ngOnInit(): void {
    this.authService
      .getUser()
      .pipe(takeUntilDestroyedSafe(this.destroyRef))
      .subscribe((user) => {
        this.user = user;
        this.buildMenu();
        this.cd.detectChanges();
      });
  }

  private buildMenu(): void {
    this.menuItems = [
      {
        title: this.translate.instant('sidebar-menu.dashboard'),
        icon: 'dashboard',
        url: '/dashboard',
      },
      {
        title: this.translate.instant('sidebar-menu.projects'),
        icon: 'projects',
        url: '/projects',
      },
      {
        title: this.translate.instant('sidebar-menu.export'),
        icon: 'documents-2',
        url: '/export',
      },
      {
        title: this.translate.instant('sidebar-menu.disc'),
        icon: 'repository',
        url: '/repository',
      },
    ];

    if (this.user?.isAdmin) {
      this.menuItems.push({
        title: this.translate.instant('sidebar-menu.bin'),
        icon: 'trash',
        url: '/bin',
      });
    }
  }

  isCurrent(menuItem: MenuItem): boolean {
    const currentUrl = this.router.url;
    const menuItemUrl = menuItem.url;
    const parentUrl = menuItemUrl.endsWith('s') ? menuItemUrl.slice(0, -1) : menuItemUrl;

    if (currentUrl.endsWith('/documentations') && menuItemUrl === '/projects') {
      return true;
    }

    if (currentUrl === menuItemUrl || currentUrl === parentUrl) {
      return true;
    }

    if (currentUrl.startsWith(parentUrl)) {
      const nextChar = currentUrl.charAt(parentUrl.length);

      if (nextChar === '/' || nextChar === '') {
        return true;
      }
    }

    return false;
  }
}
